export interface IEnviroConfig {
  readonly bannerServiceURL: string;
  readonly calendarServiceURL: string;
  readonly emailPopupPath: string;
  readonly socialMediaManagementURL: string;
  readonly staffDirServiceURL: string;
  readonly unifiedPublishingAlertServiceURL: string;
  readonly modernSocialMediaAlertsInTestMode: boolean;
}

export class EnviroConfig implements IEnviroConfig {
  public bannerServiceURL: string;
  public calendarServiceURL: string;
  public newsroomServiceURL: string;
  public createAlertServiceURL: string;
  public emailPopupPath: string;
  public iconpickerServiceURL: string;
  public newsroomApiBaseUrl: string;
  public portletLibraryServiceURL: string;
  public quicklinkportletServiceURL: string;
  public searchServiceURL: string;
  public socialMediaManagementURL: string;
  public staffDirServiceURL: string;
  public unifiedPublishingBaseURL: string;
  public unifiedPublishingAlertServiceURL: string;

  public modernSocialMediaAlertsInTestMode: boolean;

  constructor() {
    // When webpack_config_prod.ts builds the code, it has mode:production set, which sets process.env.NODE_ENV === "production"
    // When webpack_config_dev.ts builds the code, it has mode:development set, which sets process.env.NODE_ENV === "development"
    if (process.env.NODE_ENV === "production") {
      this.useProductionConfig();
    } else if (this.toBoolean(process.env.USE_NGROK) === true) {
      // NGROK is for exposing your local site and services via ngrok at an external URL. See webpack_config_dev.ts
      this.useNgrokConfig();
    } else {
        this.useDevConfig();
    }

    // // This is for accessing the site and services via my machine's local IP address. Change this to your machine's IP address if you need to debug off another machine.
    // // Occasionally useful for testing on other machines.
    // if (process.env.NODE_ENV === "remote_dev") {
    //   const localURL = "http://192.168.3.124:3000";
    //   this.staffDirServiceURL = localURL + "/staffDirectory/";
    //   this.calendarServiceURL = localURL + "/calendar/";
    //   this.unifiedPublishingAlertServiceURL = localURL + "/unifiedPublishingAlert/";
    //   this.emailPopupPath = "./";
    // }
  }

  private useDevConfig() {
    this.newsroomServiceURL = "http://localhost:3000/newsroom/";
    this.createAlertServiceURL = "http://localhost:3000/createAlert/";
    this.portletLibraryServiceURL = "http://localhost:3000/WebApi/portal/";
    this.iconpickerServiceURL = "http://localhost:3000/iconpicker/";
    this.newsroomApiBaseUrl = "http://localhost:3000/unifiedPublishing/";
    this.quicklinkportletServiceURL = "http://localhost:3000/quicklinkportlet/";
    this.searchServiceURL = "http://localhost:3000/WebApi/search/";
    this.staffDirServiceURL = "http://localhost:3000/staffDirectory/";
    this.calendarServiceURL = "http://localhost:3000/calendar/";
    this.unifiedPublishingBaseURL = "http://localhost:3000/unifiedPublishing/";
    this.unifiedPublishingAlertServiceURL = "http://localhost:3000/unifiedPublishingAlert/";
    this.bannerServiceURL = "http://localhost:3000/banner/";
    this.socialMediaManagementURL = "http://localhost:3000/webapi/";
    this.emailPopupPath = "./";
    this.modernSocialMediaAlertsInTestMode = true;
  }

  private useNgrokConfig() {
    const ngrokURL = process.env.NGROK_URL;
    this.newsroomServiceURL = ngrokURL + "/newsroom/";
    this.createAlertServiceURL = ngrokURL + "/createAlert/";
    this.portletLibraryServiceURL = ngrokURL + "/WebApi/portal/";
    this.iconpickerServiceURL = ngrokURL + "/iconpicker/";
    this.newsroomApiBaseUrl = ngrokURL + "/unifiedPublishing/";
    this.quicklinkportletServiceURL = ngrokURL + "/WebApi/quicklinkportlet/";
    this.searchServiceURL = ngrokURL + "/WebApi/search/";
    this.staffDirServiceURL = ngrokURL + "/staffDirectory/";
    this.calendarServiceURL = ngrokURL + "/calendar/";
    this.unifiedPublishingBaseURL = ngrokURL + "/unifiedPublishing/";
    this.unifiedPublishingAlertServiceURL = ngrokURL + "/unifiedPublishingAlert/";
    this.bannerServiceURL = ngrokURL + "/banner/";
    this.socialMediaManagementURL = ngrokURL + "/webapi/";
    this.emailPopupPath = "./";
    this.modernSocialMediaAlertsInTestMode = true;
  }

  private useProductionConfig() {
    this.newsroomServiceURL = "/WebApi/Newsroom/";
    this.createAlertServiceURL = "../WebServices/UnifiedPublishing/UnifiedPublishingService.asmx/";
    this.portletLibraryServiceURL = "/WebApi/portal/";
    this.iconpickerServiceURL = "/WebApi/quicklinkportlet/";
    this.newsroomApiBaseUrl = "/unifiedPublishing/";
    this.quicklinkportletServiceURL = "/WebApi/quicklinkportlet/";
    this.searchServiceURL = "/WebApi/search/";
    this.staffDirServiceURL = "../Common/controls/StaffDirectory/ws/StaffDirectoryWS.asmx/";
    this.calendarServiceURL = "../Common/controls/WorkspaceCalendar/ws/WorkspaceCalendarWS.asmx/";
    this.unifiedPublishingBaseURL = "/unifiedPublishing/";
    this.unifiedPublishingAlertServiceURL = "../WebServices/UnifiedPublishing/UnifiedPublishingService.asmx/";
    this.bannerServiceURL = "/WebApi/Banner";
    this.socialMediaManagementURL = "/WebApi/";
    this.emailPopupPath = "../common/controls/General/Email/Default.aspx?action=staffDirectoryEmail&recipients=";
    this.modernSocialMediaAlertsInTestMode = false;
  }

  private toBoolean = (x) => !!x;
}
